import { ActivityOptions } from "~/packages/taskrouter";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";




export interface SetCurrentActivityOptions {
    activityUpdateOptions?: ActivityOptions;
}




















export class SetCurrentActivity implements Action<Promise<void>> {
    


    #activitySid: string;

    


    #setCurrentActivityOptions?: SetCurrentActivityOptions;

    constructor(activitySid: string, setCurrentActivityOptions?: SetCurrentActivityOptions) {
        this.#activitySid = activitySid;
        this.#setCurrentActivityOptions = setCurrentActivityOptions;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const activityUpdateOptions = this.#setCurrentActivityOptions?.activityUpdateOptions;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        logger.debug("setCurrentActivity called with activitySid: ", this.#activitySid);

        if (!worker) {
            const errorMsg = "setCurrentActivity: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const activity = worker.activities.get(this.#activitySid);
        const workerActivity = worker.activity;

        if (this.#activitySid === workerActivity?.sid) {
            const warnMsg = `setCurrentActivity: Activity with sid ${this.#activitySid} is already set`;
            logger.warn(warnMsg);
            sendTrackingEvent(EVENTS.SetCurrentActivityCompleted, analytics, worker, {
                warning: warnMsg,
                activitySid: this.#activitySid,
                rejectPendingReservations: activityUpdateOptions?.rejectPendingReservations
            });
            return Promise.resolve();
        }

        try {
            await activity?.setAsCurrent(activityUpdateOptions);
            sendTrackingEvent(EVENTS.SetCurrentActivityCompleted, analytics, worker, {
                activitySid: this.#activitySid,
                rejectPendingReservations: activityUpdateOptions?.rejectPendingReservations
            });
            return Promise.resolve();
        } catch (error) {
            const response = error?.message;

            let errorMsg: string;

            if (
                !!response &&
                response.match(/Worker WK.* cannot have its activity updated while it has .* pending reservations/)
            ) {
                
                errorMsg = `setCurrentActivity: Failed to set current activity to activity ${
                    this.#activitySid
                } due to pending reservations`;
            } else {
                errorMsg = `setCurrentActivity: Failed to set current activity to activity ${this.#activitySid}`;
            }
            sendTrackingEvent(EVENTS.SetCurrentActivityCompleted, analytics, worker, {
                error: errorMsg,
                activitySid: this.#activitySid,
                rejectPendingReservations: activityUpdateOptions?.rejectPendingReservations
            });
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
